import React, {  useEffect, useState } from 'react';
import moment from 'moment';
import { Row, Col, Card,  Form,  OverlayTrigger, Tooltip } from 'react-bootstrap';
import { AiFillFilePdf,  AiOutlineStop } from 'react-icons/ai';
import classNames from 'classnames';
import {  useShowColumsHook } from '../../hooks/useShowColums';
import { TblHSatGlo, headTbl } from '../../data/tables';
import { useForm } from '../../hooks/useForm';
import { useGetDta } from '../../hooks/useGetDta';
import LoadinSpin from '../ui/LoadinSpin';
import PageTitle from '../PageTitle';
import Table from '../Table';
import DropDownsCol from '../ui/DropDownsCol';
import { conMoneda } from '../../helpers/details';
import ModCanclGlobal from './ModCanclGlobal';
import { getInitialColumns } from '../../data/cards';
const baseUrl = process.env.REACT_APP_API;

const ListFactGlobals = ({ activeTab }) => {
 

    const [items, setItems] = useState([]);
    const [show, setShow] = useState(false);
    const [fac, setFac] = useState({});

    const initialColums = getInitialColumns('facturas', TblHSatGlo);
    const { toggleCheck, columnasVisibles } = useShowColumsHook(initialColums, 'facturas');

    let day = moment().startOf('month').format('YYYY-MM-DD');
    let day2 = moment().endOf('month').format('YYYY-MM-DD');

    const [values, handleInputChange] = useForm({
        fechas: day,
        fechae: day2,
    });
    const { fechae, fechas } = values;
    const { loading, data, getInfo } = useGetDta(`global/facturas`);

    useEffect(() => {
        if (activeTab === 'fact-glo') getInfo();
    }, [activeTab]);
    useEffect(() => {
        getPagos();
    }, [fechae, fechas, data]);

    const getPagos = async () => {
        const fechaInicioObj = moment(fechas, 'YYYY-MM-DD'); // Convertir fecha de inicio a objeto moment
        const fechaFinObj = moment(fechae, 'YYYY-MM-DD'); // Convertir fecha de fin a objeto moment

        const items2 = data.filter((item) => {
            const fechaPagoObj = moment(item.createdAt, 'YYYY-MM-DD'); // Convertir fecha del item a objeto moment

            return fechaPagoObj.isSameOrAfter(fechaInicioObj, 'day') && fechaPagoObj.isSameOrBefore(fechaFinObj, 'day');
        });

        setItems(items2);
    };
    if (loading) return <LoadinSpin />;

    const cancel = (payload) => {
        setFac(payload);
        setShow(true);
    };

    const StatusColumn = ({ row }) => {
        return (
            <>
                <span
                    className={classNames('badge bg-success', {
                        'bg-success': row.original.state === '',
                        'bg-danger': row.original.state === 'canceled',
                        'bg-warning': row.original.state === 'pending',
                    })}>
                    {!row.original.state && <>VÁLIDO</>}
                    {row.original.state === 'pending' && <>PENDIENTE</>}
                    {row.original.state === 'canceled' && <>CANCELADO</>}
                </span>
            </>
        );
    };

    const FechaColumn = ({ row }) => {
        return <>{moment(row.original.createdAt).format('YYYY-MM-DD HH:mm:ss')}</>;
    };
    const ivaColumn = ({ row }) => {
        return <>{conMoneda(row.original.iva)}</>;
    };
    const subColumn = ({ row }) => {
        return <>{conMoneda(row.original.subtotal)}</>;
    };
    const tlColumn = ({ row }) => {
        return <>{conMoneda(row.original.total)}</>;
    };
    const ActionColumn = ({ row }) => {
        return (
            <>
                <OverlayTrigger placement="left" overlay={<Tooltip id="overlay-example">PDF </Tooltip>}>
                    <a target="_blank" href={baseUrl + row.original.url} rel="noopener noreferrer">
                        <AiFillFilePdf className="fs-5 text-black" />
                    </a>
                </OverlayTrigger>

                {row.original.state !== 'canceled'  && (
                    <>
                        <OverlayTrigger
                            className="action-icon "
                            placement="left"
                            overlay={<Tooltip id="overlay-example33">Cancelar/anular factura</Tooltip>}>
                            <span>
                                {' '}
                                <AiOutlineStop
                                    onClick={() => cancel(row.original)}
                                    className="text-lg mx-1 hover:text-blue-700"
                                />
                            </span>
                        </OverlayTrigger>
                    </>
                )}
            </>
        );
    };

    const columns = [
        {
            Header: 'Fecha',
            accessor: 'createdAt',
            sort: true,
            Cell: FechaColumn,
        },

        {
            Header: 'RFC',
            accessor: 'rfc',
            sort: true,
        },
        {
            Header: 'Folio',
            accessor: 'folio',
            sort: true,
        },
        {
            Header: 'Forma pago',
            accessor: 'forma_p',
            sort: true,
        },
        {
            Header: 'IVA',
            accessor: 'iva',
            sort: true,
            Cell: ivaColumn,
        },
        {
            Header: 'Subtotal',
            accessor: 'subtotal',
            sort: true,
            Cell: subColumn,
        },
        {
            Header: 'Total',
            accessor: 'total',
            sort: true,
            Cell: tlColumn,
        },

        {
            Header: 'Estado',
            accessor: 'state',
            sort: true,
            Cell: StatusColumn,
        },

        {
            Header: 'Acción',
            accessor: 'action',
            sort: false,
            classes: 'table-action',
            Cell: ActionColumn,
        },
    ];
    const sizePerPageList = headTbl(items.length);

    return (
        <div>
            {' '}
            <PageTitle
                breadCrumbItems={[
                    { label: 'Finanzas', path: '/' },
                    { label: 'Facturas globales', path: '/admin/global', active: true },
                ]}
                title={'Facturas globales'}
            />{' '}
            <Row>
                <Col xs={12}>
                    <Card>
                        <Card.Body>
                            {' '}
                            <Table
                                columns={columns}
                                data={items}
                                pageSize={25}
                                sizePerPageList={sizePerPageList}
                                isSortable={true}
                                pagination={true}
                                columnasVisibles={columnasVisibles}
                                isSearchable={true}
                                theadClass="table-light"
                                searchBoxClass="mb-2"
                                visiblesCustum={
                                    <div className="d-flex">
                                        <DropDownsCol
                                            cols={columnasVisibles} // Pasar el estado desde TblZonas
                                            toggleCheck={toggleCheck} // Pasar la función de toggleCheck desde TblZonas
                                        />
                                        <Form.Group
                                            className="mx-2 mb-3 d-flex align-items-center ml-2"
                                            controlId="validationCustofs">
                                            <Form.Label className="mx-2">Fechas</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="fechas"
                                                value={values.fechas}
                                                onChange={handleInputChange}
                                            />
                                        </Form.Group>{' '}
                                        <Form.Group
                                            className="mb-3 d-flex align-items-center ml-2"
                                            controlId="validationCustofe">
                                            <Form.Label>al</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="fechae"
                                                value={values.fechae}
                                                onChange={handleInputChange}
                                            />
                                        </Form.Group>{' '}
                                    </div>
                                }
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ModCanclGlobal show={show} onClose={() => setShow(false)} data={fac} callBk={getInfo} />
        </div>
    );
};

export default ListFactGlobals;
